<template>
  <div v-if="mappedCodes.length">
    {{ entry.competition.code }} -
    <AppChip
      v-for="feiCode in mappedCodes"
      :key="feiCode"
      color="black"
      class-list="ma-1 text-white"
    >
      {{ feiCode }}
    </AppChip>
  </div>
</template>
<script>
import gql from "fraql";
import { defineComponent, computed, toRefs } from "vue";
import AppChip from "@elements/AppChip.vue";

export default defineComponent({
  name: "AppShowMappedFeiCompetitionCodes",
  components: { AppChip },
  props: {
    competition: {
      type: Object,
      required: true
    },
    entry: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { entry, competition } = toRefs(props);
    const mappedCodes = computed(() => {
      let mapping = competition.value.forRegistrationToFeiCompetitions;
      if (!mapping) mapping = [];

      return (entry.value.registeredToFeiCompetitionCodes ?? []).map(
        feiCode => {
          const map = mapping.find(x => x.competitionCode == feiCode);
          return map?.competitionName ?? feiCode;
        }
      );
    });

    return { mappedCodes };
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        code
        forRegistrationToFeiCompetitions
      }
    `,
    entryFields: gql`
      fragment _ on Entry {
        registeredToFeiCompetitionCodes
      }
    `
  }
});
</script>
